<!-- src/app/forgot-password/forgot-main/forgot-main.component.html -->
<div class="forgot-page">
  <div class="content">
    <app-leftsection class="left text-center"> </app-leftsection>
    <div class="divider"></div>
    <app-rightsection class="right"> </app-rightsection>
  </div>
</div>
